<template>
  <van-form ref="vanForm" validate-first class="item_main">
    <van-cell-group>
      <template v-if="form.ydlb.value">
        <van-field
          input-align="right"
          v-model="defValueMap.ydwh"
          label="异动文号"
          :disabled="info.ydwhsfqy === '1'"
        />
        <van-field
          input-align="right"
          v-model="info.nowtime"
          label="异动日期"
          disabled
        />
        <van-field
          input-align="right"
          v-model="defValueMap.xz"
          label="学制"
          disabled
        />
        <van-field
          input-align="right"
          v-model="defValueMap.sznj"
          label="所在年级"
          disabled
        />
        <van-field
          input-align="right"
          v-model="defValueMap.yxmc"
          label="院系名称"
          disabled
        />
        <van-field
          input-align="right"
          v-model="form.zymc.text"
          label="专业名称"
          placeholder="请选择"
          right-icon="arrow"
          @click="showSearchpPop('毕业专业', 'zymc', kzData.zysfkxz === '0')"
          :readonly="kzData.zysfkxz !== '0'"
          :disabled="kzData.zysfkxz === '0'"
          :required="kzData.zysfbt === '1'"
          :rules="[
            { required: kzData.zysfbt === '1', message: '请选择专业名称' }
          ]"
        />
        <van-field
          input-align="right"
          v-model="defValueMap.pycc"
          label="培养层次"
          disabled
        />
      </template>
      <van-field
        input-align="right"
        v-model="form.ydlb.text"
        label="异动类别"
        placeholder="请选择"
        right-icon="arrow"
        readonly
        @click="showPop('异动类别', 'ydlb')"
        required
        :rules="[{ required: true, message: '请选择异动类别' }]"
      />
      <template v-if="form.ydlb.value">
        <!-- 异动申请 -->
        <van-field
          input-align="right"
          v-model="form.ydyy.text"
          label="异动原因"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop('异动原因', 'ydyy')"
          required
          :rules="[{ required: true, message: '请选择异动原因' }]"
        />
        <van-field
          input-align="right"
          v-model="form.sxxq.text"
          label="生效学期"
          placeholder="请选择"
          right-icon="arrow"
          @click="showPop('生效学期', 'sxxq', kzData.sxxqsfkxg === '0')"
          required
          :readonly="kzData.sxxqsfkxg !== '0'"
          :disabled="kzData.sxxqsfkxg === '0'"
          :rules="[
            { required: kzData.sxxqsfkxg !== '0', message: '请选择生效学期' }
          ]"
        />
        <van-field
          input-align="right"
          v-model="form.bjmc.text"
          label="班级名称"
          placeholder="请选择"
          right-icon="arrow"
          @click="
            showSearchpPop(
              '班级名称',
              'bjmc',
              kzData.bjsfkxz === '0' || !form.zymc.value
            )
          "
          :readonly="kzData.bjsfkxz !== '0'"
          :disabled="kzData.bjsfkxz === '0' || !form.zymc.value"
          :required="kzData.bjsfbt === '1'"
          :rules="[
            { required: kzData.bjsfbt === '1', message: '请选择班级名称' }
          ]"
        />
        <van-field
          input-align="right"
          v-model="form.byzy.text"
          label="毕业专业"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showSearchpPop('毕业专业', 'byzy')"
          :required="kzData.byzysfbt === '1'"
          :rules="[
            { required: kzData.byzysfbt === '1', message: '请选择毕业专业' }
          ]"
        />
        <van-field
          input-align="right"
          v-model="form.ydqx.text"
          label="异动去向"
          placeholder="请输入"
          @input="val => changeValue(val, 'ydqx')"
        />
        <van-field
          input-align="right"
          v-model="form.ydly.text"
          label="异动理由"
          placeholder="请输入"
          :required="kzData.lysfbt === '1'"
          :rules="[
            { required: kzData.lysfbt === '1', message: '请输入异动理由' }
          ]"
          @input="val => changeValue(val, 'ydly')"
        />
        <van-field
          input-align="right"
          v-model="form.fjyqsm.text"
          label="附件要求说明"
          placeholder="请输入"
          @input="val => changeValue(val, 'fjyqsm')"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="showSearch" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="showSearch = false"
        @confirm="
          (value, index) => {
            onConfirmSearch(value, index, valueList.field);
          }
        "
      >
        <template #columns-top>
          <van-search
            v-model="value"
            shape="round"
            background="rgba(116, 105, 248)"
            placeholder="请输入搜索关键词"
          />
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>
<script>
import { Dialog } from "vant";
import { Api } from "@/utils/axios";
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    selectDataMap: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    selectDataMap: {
      handler(newVal) {
        this.columns = newVal;
      },
      deep: true,
      immediate: true
    },
    "form.ydlb": {
      handler(newVal) {
        this.getYdyy(newVal.value);
        this.form.ydyy = { text: "", value: "" };
      },
      deep: true
    },
    showSearch: {
      handler(newVal) {
        if (!newVal) {
          this.value = "";
        }
      },
      deep: true
    },
    value: {
      handler(newVal) {
        let column = this.columns[this.valueList.field];
        this.valueList.columns[0].values = column[0].values.filter(
          (item, index) => {
            if (item.text && item.text.indexOf(newVal) != -1) {
              item.defaultIndex = index;
              return true;
            }
            return false;
          }
        );
      },
      deep: true
    },
    "form.zymc": {
      handler(newVal) {
        this.changeByzy(newVal);
        this.getBj(newVal.value);
        this.form.bjmc = { text: "", value: "" };
      },
      deep: true
    },
    "form.bjmc": {
      handler(newVal, oldVal) {
        if (newVal.value !== oldVal.value) {
          this.changeByzy(this.form.zymc);
        }
      },
      deep: true
    }
  },
  data() {
    return {
      value: "",
      defValueMap: {},
      form: {
        zymc: {
          text: "",
          value: ""
        },
        ydlb: {
          text: "",
          value: ""
        },
        ydyy: {
          text: "",
          value: ""
        },
        sxxq: {
          text: "",
          value: ""
        },
        bjmc: {
          text: "",
          value: ""
        },
        byzy: {
          text: "",
          value: ""
        },
        ydqx: {
          text: "",
          value: ""
        },
        ydly: {
          text: "",
          value: ""
        },
        fjyqsm: {
          text: "",
          value: ""
        }
      },
      showSearch: false,
      show: false,
      valueList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {},
      kzData: {},
      modeFile: ""
    };
  },
  methods: {
    changeByzy(newVal) {
      if (newVal.defaultIndex) {
        this.columns["byzy"].defaultIndex = newVal.defaultIndex;
      }
      this.form["byzy"] = newVal;
    },
    changeValue(val, field) {
      this.form[field].value = val;
    },
    savData() {
      if (this.kzData.fjsfbt === "1" && this.modeFile.filesList.length == 0) {
        this.$toast.fail("请上传附件！");
        return;
      }
      this.$refs.vanForm.validate().then(
        async () => {
          let params = {
            type: "check",
            // 异动类别
            ydlb: this.form.ydlb.value,
            // 学号
            xh: this.info.xh,
            // 专业id
            jx01ndid: this.defValueMap.jx01ndid,
            // 学生id
            xs0101id: this.info.xs0101id,
            // 异动文号
            ydwh: this.defValueMap.ydwh
          };
          let formData = new FormData();
          Object.keys(params).forEach(key => {
            formData.append(key, params[key]);
          });
          const res = await Api.saveXsydsq(formData);
          if (res.code == "1") {
            if (res.Msg) {
              Dialog.confirm({
                message: res.Msg
              })
                .then(() => {
                  this.submit();
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              this.submit();
            }
          }
        },
        () => {}
      );
    },
    async submit() {
      let params = {
        // 异动类别
        ydlb: this.form.ydlb.value,
        // 异动原因
        ydyy: this.form.ydyy.value,
        // 异动日期
        ydrq: this.info.nowtime,
        // 生效学期
        sxxq: this.form.sxxq.value,
        // 班级id
        xx04id: this.form.bjmc.value,
        // 异动文号
        ydwh: this.defValueMap.ydwh,
        // 异动去向
        ydqx: this.form.ydqx.value,
        // 异动理由
        ydly: this.form.ydly.value,
        // 毕业专业id
        byzyid: this.form.byzy.value,
        // 流水号
        lshshow: this.defValueMap.lshshow,
        // 专业id
        newydzy: this.form.zymc.value
      };
      let formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      // 附件
      this.modeFile.filesList.forEach(file => {
        formData.append("file", file.file);
      });

      const res = await Api.saveXsydsq(formData);
      if (res.code == 1) {
        this.$toast.success("异动申请提交成功");

        setTimeout(() => {
          this.$router.replace("/xjydsq/index?active=" + this.info.active);
        }, 1500);
      }
    },
    async getBj(val) {
      const res = await Api.findDictionry({ zzdtype: "bj", jx01ndid: val });
      if (res.code == "1") {
        let defaultIndexBj = 0;
        this.columns.bjmc = [
          {
            values: res.data.bj.map((item, index) => {
              if (this.defValueMap.xx04id === item.xx04id) {
                defaultIndexBj = index;
                this.form.bjmc = {
                  text: item.bj,
                  value: item.xx04id
                };
              }
              return {
                text: item.bj,
                value: item.xx04id
              };
            }),
            defaultIndex: defaultIndexBj
          }
        ];
      }
    },
    async getYdyy(val) {
      const res = await Api.findYdyy({ ydlb: val });
      if (res.code == "1") {
        this.modeFile = this.$parent.$parent.$parent.$refs.modeFile;
        this.defValueMap = res.data.defValueMap;
        this.form.zymc = this.info.zymc;
        this.form.fjyqsm.text = this.defValueMap.fjsm;
        this.form.fjyqsm.value = this.defValueMap.fjsm;
        this.kzData = res.data.kzdata;
        this.modeFile.fjsfbt = res.data.kzdata.fjsfbt;
        this.columns.ydyy = [
          {
            values: res.data.ydyyList.map(item => {
              return {
                text: item.ydyymc,
                value: item.dm
              };
            })
          }
        ];
      }
    },
    // 弹出搜索选择器
    showSearchpPop(title, field, flag) {
      if (flag) return;
      this.showSearch = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = JSON.parse(JSON.stringify(this.columns[field]));
    },
    // 搜索选择确认
    onConfirmSearch(value, index, field) {
      this.showSearch = false;
      this.form[field] = value[0];
      if (value[0].defaultIndex) {
        this.columns[this.valueList.field][0].defaultIndex =
          value[0].defaultIndex;
      }
      //   this.getList();
    },
    // 弹出选择器
    showPop(title, field, flag) {
      if (flag) return;
      this.show = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = JSON.parse(JSON.stringify(this.columns[field]));
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field] = value[0];
      //   this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.item_main {
  margin: -14px -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/mode/modeYdhqzkApply.vue